var _path, _path2, _path3, _path4, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _path5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExpiredState(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 176,
    height: 87,
    viewBox: "0 0 176 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.16 30.3442H94.56C96.7692 30.3442 98.56 32.1351 98.56 34.3442V82.2787H28.16V30.3442Z",
    fill: "#D8DDEB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M103.253 15H162.613C164.822 15 166.613 16.7909 166.613 19V82.2787H103.253V15Z",
    fill: "#D8DDEB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5601 34.3442C10.5601 32.1351 12.3509 30.3442 14.5601 30.3442H71.0934C73.3025 30.3442 75.0934 32.1351 75.0934 34.3442V82.2787H10.5601V34.3442Z",
    fill: "#EAEEF4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M85.6533 19C85.6533 16.7909 87.4442 15 89.6533 15H146.187C148.396 15 150.187 16.7909 150.187 19V82.2787H85.6533V19Z",
    fill: "#EAEEF4"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 82.2787,
    width: 176,
    height: 4.72131,
    rx: 2.36066,
    fill: "#F5F8FA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 28.16,
    y: 48.0492,
    width: 28.16,
    height: 16.5246,
    rx: 4,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 32.8533,
    y: 51.5902,
    width: 2.34667,
    height: 9.44262,
    rx: 1.17333,
    fill: "#D8DDEB"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 37.5466,
    y: 51.5902,
    width: 4.69334,
    height: 9.44262,
    rx: 2.34667,
    fill: "#D8DDEB"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 44.5867,
    y: 51.5902,
    width: 2.34667,
    height: 9.44262,
    rx: 1.17333,
    fill: "#D8DDEB"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 49.28,
    y: 51.5902,
    width: 2.34667,
    height: 9.44262,
    rx: 1.17333,
    fill: "#D8DDEB"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 103.253,
    y: 40.9672,
    width: 28.16,
    height: 16.5246,
    rx: 4,
    fill: "white"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 107.947,
    y: 44.5082,
    width: 2.34667,
    height: 9.44263,
    rx: 1.17334,
    fill: "#D8DDEB"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 112.64,
    y: 44.5082,
    width: 4.69334,
    height: 9.44263,
    rx: 2.34667,
    fill: "#D8DDEB"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 119.68,
    y: 44.5082,
    width: 2.34666,
    height: 9.44263,
    rx: 1.17333,
    fill: "#D8DDEB"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 124.373,
    y: 44.5082,
    width: 2.34666,
    height: 9.44263,
    rx: 1.17333,
    fill: "#D8DDEB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.92 29.1639C169.696 29.1639 176 22.8226 176 15C176 7.17747 169.696 0.83606 161.92 0.83606C154.144 0.83606 147.84 7.17747 147.84 15C147.84 22.8226 154.144 29.1639 161.92 29.1639ZM163.68 7.91803C163.68 6.94022 162.892 6.14754 161.92 6.14754C160.948 6.14754 160.16 6.94022 160.16 7.91803V15C160.16 15.4695 160.345 15.9199 160.675 16.2519L165.653 21.2596C166.341 21.9511 167.455 21.9511 168.142 21.2596C168.83 20.5682 168.83 19.4471 168.142 18.7557L163.68 14.2666V7.91803Z",
    fill: "url(#paint0_linear_3633_19490)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3633_19490",
    x1: 133.76,
    y1: 15,
    x2: 162.087,
    y2: 43.1595,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007CFF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpiredState);
export default __webpack_public_path__ + "static/media/expired-state.d6a0463d.svg";
export { ForwardRef as ReactComponent };